'use client'

import { memo, Suspense, useEffect, useState } from 'react'
import ExpandButton from '@dustin-web/microsite-components/src/expand-button'
import { useTranslations } from '@dustin-web/microsite-components/src/hooks'
import { Skeleton } from '@dustin-web/microsite-components/src/skeleton'
import type { Product } from '@productsite-beta/src/graphql/generated/graphql-types'
import ProductCard from './product-card/product-card'

import './product-up-sell.scss'

type Props = {
  products: Product[]
  mainProductTicket: string
  isMobile: boolean
}

const ProductUpSell = ({ products: list, mainProductTicket, isMobile }: Props) => {
  const [showAll, setshowAll] = useState(false)
  const { translate } = useTranslations()

  const initalProductCount = isMobile ? 1 : 3
  const products = showAll ? list : list.slice(0, initalProductCount)

  //This logic recenters the mobile view onto the list because the layout uses a grid.
  //If the list's position in the layout changes, this code must be re-evaluated.
  useEffect(() => {
    if (!isMobile || !showAll) {
      return
    }

    const frame = requestAnimationFrame(() => {
      document.getElementById('up-sell-header')?.scrollIntoView({
        behavior: 'instant',
        block: 'start',
      })
    })

    return () => cancelAnimationFrame(frame)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showAll])

  const toggleShowAll = () => {
    setshowAll(state => !state)
  }

  return (
    <div className="product-upp-sell">
      <div id="up-sell-header" className="header">
        <h2 className="h4">{translate('Product_UpSell_Header')}</h2>
      </div>
      <div className="products-wrapper">
        <Suspense
          fallback={Array.from({ length: initalProductCount }).map((_, index) => {
            return <Skeleton key={index} height={isMobile ? 160 : 135} />
          })}>
          {products?.map((product, key) => (
            <ProductCard
              key={key}
              digitalIndex={key}
              product={product as Product}
              isSmallScreen={isMobile}
              ticket={mainProductTicket}
              addToCartText={translate('Add')}
              digitalDataOrigin="othersBought"
            />
          ))}
        </Suspense>
      </div>
      {list?.length > initalProductCount && (
        <ExpandButton
          className="u-pt-12"
          onClick={toggleShowAll}
          collapsedTitle={translate('ShowMore')}
          expandedTitle={translate('ShowLess')}
          expanded={showAll}
          ariaControls="expandable-upp-sell-cards"
        />
      )}
    </div>
  )
}

export default memo(ProductUpSell)
